import Domain from "./domain";
export default {
  methods: {
    postCompanyToStudentBulk: async function(obj) {
      console.log("student");
      console.log(obj);
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/student/bulk",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    // type:csv-student
    // format:2
    // path:bulk
    // image:ST_6221.csv
    postCompanyToStudentCSVBulk: async function(obj) {
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/student/csv/bulk/",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Max-Age": "600",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept, Authorization"
            },
            timeout: 30000
          }
        );
        console.log(response);
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    postCompanyToStaffBulk: async function(obj) {
      console.log("staff");
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/staff/bulk",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    // type:csv-staff
    // format:2
    // path:bulk
    // SF_6221.csv
    postCompanyToStaffCSVBulk: async function(obj) {
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/staff/csv/bulk/",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Max-Age": "600",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept, Authorization"
            },
            timeout: 30000
          }
        );
        console.log(response);
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    postCompanyToVisitorBulk: async function(obj) {
      console.log("visitor");
      console.log(obj);
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/visitor/bulk",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postCompanyToContractorBulk: async function(obj) {
      console.log("contractor");
      console.log(obj);
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/contractor/bulk",
          obj,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "multipart/form-data"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    staffJsonBulk: async function(json) {
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/staff/json/bulk",
          json,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "application/json"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    studentsJsonBulk: async function(json) {
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/student/json/bulk",
          json,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "application/json"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    studentsJsonBulkUpdate: async function(json) {
      try {
        const AuthStr = "Bearer ".concat(localStorage.token);
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/student/json/bulk",
          json,
          {
            headers: {
              Authorization: AuthStr,
              "Content-Type": "application/json"
            }
          }
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
